import { useState, useEffect } from 'react';
import { generateUUID } from '@wix/form-schema';
export const useAtlas = _ref => {
  let {
    enabled,
    getInstance,
    language,
    locale,
    atlasBaseUrl
  } = _ref;
  const [atlas, setAtlas] = useState();
  const instance = getInstance();
  const [sessionToken, setSessionToken] = useState(generateUUID());
  const refreshSessionToken = () => setSessionToken(generateUUID());
  useEffect(() => {
    if (!enabled) {
      return;
    }
    const initAtlas = async () => {
      try {
        const {
          createAtlasService
        } = await import(/* webpackChunkName: "atlas-service" */'./atlas-service');
        const atlasService = createAtlasService({
          getInstance: () => instance,
          sessionToken,
          refreshSessionToken,
          language,
          locale,
          atlasBaseUrl
        });
        setAtlas(atlasService);
      } catch (_error) {}
    };
    initAtlas();
  }, [enabled, instance, language, locale, sessionToken, atlasBaseUrl]);
  return atlas;
};
//# sourceMappingURL=use-atlas.js.map